import { defaultClusterLabel }
	from 'scoreboard/datasets/filters/label-clusters-form'


function clusterLabel(value, clusterLabels) {
	const labelEntry = (clusterLabels || [])
		.find(it => it.index === value)
	if (labelEntry) {
		return labelEntry.label
	}

	return defaultClusterLabel(value)
}

export default clusterLabel
clusterLabel.__filename__ = 'datasets/edit/fields/cluster-label.js'
